var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5368 10.8865L21.0908 9.33249C21.9694 8.4538 21.9694 7.02915 21.0907 6.15048L18.2592 3.31913C17.3806 2.44049 15.956 2.4405 15.0773 3.31917L13.5234 4.87309L19.5368 10.8865Z",
    fill: "#520A76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4763 11.947L9.9776 20.4459C9.57739 20.8461 9.06343 21.1131 8.50587 21.2104L3.12896 22.1488C2.88837 22.1908 2.64239 22.113 2.46969 21.9403C2.29698 21.7676 2.21919 21.5217 2.26118 21.2811L3.19948 15.9045C3.29679 15.3469 3.56377 14.833 3.96398 14.4327L12.463 5.93359L18.4763 11.947Z",
    fill: "#520A76"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b2cca0b0cde50f0f875f13594e9a3b42.svg";
export { ForwardRef as ReactComponent };